import css from 'styled-jsx/css';

const staticStyles = css.global`
  .InfoTooltip {
    svg {
      color: #858585;
    }

    :global(.react-tooltip) {
      opacity: 1;
      background-color: #fff !important;
      color: #000;
      box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
    }
  }
`;

export { staticStyles };
